import { useEffect } from 'react';
import type { AgoraRoomLike } from '../../../types';
import { Callback } from '../../../types';

export default function useHandleRoomDisconnection(
  room: AgoraRoomLike | null,
  onError: Callback,
  removeLocalAudioTrack: () => void,
  removeLocalVideoTrack: () => void,
  isSharingScreen: boolean,
  toggleScreenShare: () => void
) {
  useEffect(() => {
    if (!room) return;
    const client = room.client;
    const handleStateChange = (state: string) => {
      if (state === 'DISCONNECTED' || state === 'FAILED') {
        removeLocalAudioTrack();
        removeLocalVideoTrack();
        if (isSharingScreen) toggleScreenShare();
      }
    };
    client.on('connection-state-change', handleStateChange);
    return () => client.off('connection-state-change', handleStateChange);
  }, [room, onError, removeLocalAudioTrack, removeLocalVideoTrack, isSharingScreen, toggleScreenShare]);
}
